import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "brand-text font-weight-dark" }, "INVENTÁRIO", -1)
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = { class: "user-panel mt-3 pb-3 mb-3 d-flex" }
const _hoisted_4 = { class: "image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = {
  class: "nav nav-pills nav-sidebar flex-column",
  "data-widget": "treeview",
  role: "menu",
  "data-accordion": "false"
}

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_app_menu_item = _resolveComponent("app-menu-item")

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["main-sidebar elevation-1", _ctx.sidebarSkin])
  }, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "brand-link",
      style: {"text-align":"center"}
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: (_ctx.user && _ctx.user.picture) ? _ctx.user.picture : require('@/assets/img/default-profile.png'),
            class: "img-circle elevation-2",
            alt: "User Image"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/profile",
            class: "d-block"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.user && _ctx.user.email), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("nav", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item) => {
            return (_openBlock(), _createBlock(_component_app_menu_item, { menuItem: item }, null, 8, ["menuItem"]))
          }), 256))
        ])
      ])
    ])
  ], 2))
}